var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-circle-fill",
    gradientTransform: "translate(-111.65 -194.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5189",
    x1: 151.17,
    x2: 155.53,
    y1: 96.594,
    y2: 96.594,
    gradientTransform: "matrix(2.48 0 0 2.5238 -359.05 39.653)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#light-circle-fill"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5191",
    x1: 147.63,
    x2: 151.99,
    y1: 96.594,
    y2: 96.594,
    gradientTransform: "matrix(2.48 0 0 2.5238 -358.14 39.653)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#light-circle-fill"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5193",
    x1: 144.09,
    x2: 148.45,
    y1: 96.594,
    y2: 96.594,
    gradientTransform: "matrix(2.48 0 0 2.5238 -357.23 39.653)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#light-circle-fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -270.54)",
    fill: "none",
    strokeWidth: 2.1167
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.93975 276.85 7.9226 6.6344-7.7594 6.539",
    stroke: "url(#linearGradient5193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8182 276.85 7.9226 6.6344-7.7594 6.539",
    stroke: "url(#linearGradient5191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.697 276.85 7.9226 6.6344-7.7594 6.539",
    stroke: "url(#linearGradient5189)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.76fafeefb0c8547deab3f06f2394aec2.svg";